var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "        <span id=\"info\" class=\"sidePanelTglBtn iwr\" data-panel=\"indexInfo\" title=\"Document Indexes\">\n             <i class=\"icon-info-circled\"></i>\n        </span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "hide";
},"5":function(container,depth0,helpers,partials,data) {
    return "\n        <span id=\"find-and-redact-toggle-btn\" class=\"sidePanelTglBtn iwr\" data-panel=\"findAndRedact\" title=\"Find and Redact\">\n            <i class=\"fr-icon-search icon-search-outline\" ></i>\n            <i class=\"fr-icon-edit icon-pencil-alt\"></i>\n        </span>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"FV-sideHeader-inner\">\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndexes : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n    <span id=\"toggleThumbs\" class=\"sidePanelTglBtn iwr "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.showThumbnails : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-panel=\"thumbs\" title=\"Thumbnails\">\n         <i class=\"icon-th-list-2\"></i>\n    </span>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeFindAndRedactModule : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerLeft/headerLeft.hbs
 ** module id = 734
 ** module chunks = 0
 **/